<template>
  <div class="mobile-container" @touchmove.prevent>
    <TopTitle/>
    <!--    <div class="custom-div">
          <div class="text-panel">守护每一颗梨的成长过程</div>
          <div><img class="qr-code" src="resource/qrCode1.png"/></div>
        </div>-->
    <div class="custom-div" @click="goToAbout">
      <el-carousel width="94vw" height="30vh" loop="true" motion-blur arrow="never"
                   touchable="true" indicator-position="inside">
        <el-carousel-item :key="1">
          <img src="../resource/slideshow1.jpg" class="slideshow-img"/>
        </el-carousel-item>

        <el-carousel-item :key="2">
          <img src="../resource/slideshow2.jpg" class="slideshow-img"/>
        </el-carousel-item>

        <el-carousel-item :key="3">
          <img src="../resource/slideshow3.jpg" class="slideshow-img"/>
        </el-carousel-item>

        <el-carousel-item :key="4">
          <img src="../resource/slideshow4.jpg" class="slideshow-img"/>
        </el-carousel-item>

      </el-carousel>
    </div>
    <div class="notice-activity">
      <li size="large" class="notice-activity-italic">活动公告</li>
      <li size="large" class="notice-activity-text" @click="goToNoticeActivity('/Order')">新鲜黄金梨大丰收，快来品尝吧！点击购买</li>
      <li size="large" class="notice-activity-text" @click="goToNoticeActivity('/OrganizeActivity')">第六期果园采摘体验进行中，点我了解详情！</li>
      <li size="large" class="notice-activity-text" @click="goToNoticeActivity('/OrganizeActivity')">第四期VR体验火热进行中，快来参与吧！</li>
      <li size="large" class="notice-activity-text" @click="goToNoticeActivity('/OrganizeActivity')">更多活动火热进行中！</li>
    </div>
    <div class="function-box">
      <div class="child-box1" @click="goToOrder">
        <img class="picture-italic" src="../resource/shoppingCar.svg">
        <el-space direction="vertical" class="text-order">
          <el-text size="large" class="font-bold-italic">点击下单</el-text>
        </el-space>
      </div>
      <div class="child-box4"   @click="goToTraceBarCode">
        <img class="picture-italic" src="../resource/uniqueCode.svg">
        <el-space direction="vertical" class="text-order">
          <el-text size="large" class="font-bold-italic">一树一码</el-text>
        </el-space>
      </div>
    </div>
    <div class="function-box2">
      <div class="child-box2" @click="goToCredits">
        <img class="picture-italic" src="../resource/uniqueCode.svg">
        <el-space direction="vertical" class="text-order">
          <el-text size="large" class="font-bold-italic">积分兑换</el-text>
        </el-space>
      </div>
      <div class="child-box3">
        <div class="child-box3-child1" @click="isDialogOpen=true">
          <img class="picture-italic" src="../resource/member.svg">
          <el-space direction="vertical" class="text-order">
            <el-text size="large" class="font-bold-italic">入会</el-text>
          </el-space>
        </div>
        <div class="child-box3-child2"  @click="goToOrganizeActivity">
          <img class="picture-italic" src="../resource/activity.svg">
          <el-space direction="vertical" class="text-order">
            <el-text size="large" class="font-bold-italic">活动</el-text>
          </el-space>
        </div>
      </div>
    </div>
    <el-dialog
        v-model="isDialogOpen"
        title="扫码关注公众号"
        class="dialog-class"
        width="80vw"
        :style="{ 'max-height': '80vh' }"
        :append-to-body="true"
        :destroy-on-close="true"
    >
      <!-- 嵌入目标页面组件 -->
      <img class="custom-vip" src="../resource/vip.png"/>
    </el-dialog>
    <!--    <div class="profile-div">
          <div class="text-profile">每个梨的精品照片</div>
          <div><img class="profile-picture" src="resource/qrCode1.png"/></div>
        </div>-->
    <!--    <div class="profile-div">
          <div class="text-profile">讲好每一个梨的故事</div>
          <div><img class="profile-picture" src="resource/qrCode1.png"/></div>
        </div>
        <div class="profile-div">
          <div class="text-profile">种好每一颗梨树</div>
          <div><img class="profile-picture" src="resource/qrCode1.png"/></div>
        </div>-->
  </div>
</template>

<script setup>
import {onMounted, ref} from 'vue';
import 'element-plus/es/components/carousel/style/css';
import 'element-plus/es/components/carousel-item/style/css';
import {useRouter} from 'vue-router';

// 1. 直接定义路由实例（无需放在 setup() 里）
const router = useRouter();

// 2. 直接定义弹框控制变量（自动暴露给模板，无需 return）
const isDialogOpen = ref(false);

// 3. 组件挂载逻辑（直接写，无需嵌套在 setup() 里）
onMounted(() => {
  // user.value = JSON.parse(sessionStorage.getItem("loginUser"));
});

// 4. 跳转函数（直接定义，自动暴露给模板，无需 return）
const goToAbout = () => {
  router.push({
    path: '/SightseeingTour',
    query: {from: 'home-page'}
  });
};

const goToOrganizeActivity = () => {
  router.push({
    path: '/OrganizeActivity',
    query: {from: 'home-page'}
  });
};

const goToTraceBarCode = () => {
  router.push({
    path: '/TraceBarCode',
    query: {from: 'home-page'}
  });
};

const goToOrder = () => {
  router.push({path: '/Order'});
};

const goToCredits = () => {
  router.push({path: '/Credits'});
};

/*活动公告的跳转*/
const goToNoticeActivity = (path) => {
  if (isEmpty(path)){
    return;
  }
  router.push({path: path});
};

function isEmpty(value) {
  return value === null ||
      value === undefined ||
      (typeof value === 'string' && value.trim() === '') ||
      (typeof value === 'number' && isNaN(value)); // NaN特殊处理
}

// 5. 定义组件名（可选，Vue3.3+ 支持，替代原来的 name 选项）
// eslint-disable-next-line
defineOptions({
  name: 'MobileMain'
});
</script>

<style scoped>
/* 可选：清除默认边距，避免滚动异常 */
body, html {
  margin: 0;
  padding: 0;
  touch-action: none; /* 禁止页面整体触摸滑动 */
}

/* 基础样式 */
.mobile-container {
  height: 93vh;
  width: 100vw;
  position: fixed;
  overflow-y: auto;
  touch-action: none; /* 禁止触摸交互 */
  /*background-color: #fdf8e5; !* 黄色*!*/
  background-color: #F2F2E8; /* 白色*/
  /*background: linear-gradient(to bottom right, #33872B, #d8ffd0);*/
  /*background-color: #EAF0E6;*/ /* 黄白色*/
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}

/*上部的梨子的父级框*/
.custom-div {
  /* 圆角5px */
  border-radius: 5px;
  /* 外填充（外边距）2vh */
  margin-top: 1vh;
  margin-left: 2vw;
  margin-right: 2vw;
  /* 给个基础尺寸，可根据需求调整 */
  width: 96vw;
  overflow: hidden;
  /* 背景图设置 */
  /*  background-image: url('/resource/p1.png');
    !* 背景图自适应 *!
    background-size: cover; !* 覆盖整个区域，可能裁剪 *!
    !* 可选：保持背景图比例并完全显示 *!
    !* background-size: contain; *!
    !* 背景图位置居中 *!
    background-position: center;
    !* 防止背景图重复 *!
    background-repeat: no-repeat;*/
  /* 给个基础尺寸，可根据需求调整 */
  height: 32%;
}

.slideshow-img {
  max-width: 100%; /* 宽度不超过父容器 */
  height: auto; /* 高度按比例自动调整 */
  display: block; /* 消除图片底部缝隙 */
}

/*活动公告*/
.notice-activity {
  flex: 1;
  overflow: hidden;
  /* 核心：开启Flex布局，子元素自动横向排列 */
  /*  display: flex;*/
  /* 可选：子元素之间的间距（按需调整） */
  gap: 10px;
  /* 可选：子元素分布方式（两端对齐/均匀分布等） */
  /* justify-content: space-between; */
  /* 给个基础尺寸，可根据需求调整 */
  width: 96vw;
  height: 18%;
  /* 外填充（外边距）2vh */
  margin-top: 1vh;
  margin-left: 2vw;
  margin-right: 2vw;
  /*border: 10px;*/
}

.notice-activity-italic {
  width: auto;
  color: #000; /* 字体加黑（黑色） */
  font-weight: bold; /* 加粗 */
  font-size: 28px;
  text-align: center;
  list-style: none;
  /*font-style: italic; *//* 斜体 */
}
.notice-activity-text {
  margin-top: 5px;
  width: auto;
  font-size: 18px;
  color: #000; /* 字体加黑（黑色） */
  text-align: left;
  list-style: none;
  /*font-style: italic; *//* 斜体 */
}

/*主内容盒子*/
.function-box {
  flex: 1;
  overflow: hidden;
  /* 可选：优化滚动体验（iOS端） */
  -webkit-overflow-scrolling: touch;
  /* 核心：开启Flex布局，子元素自动横向排列 */
  display: flex;
  /* 可选：子元素之间的间距（按需调整） */
  gap: 10px;
  align-items: flex-start; /* 垂直顶部对齐 */
  justify-content: center; /* 水平居中对齐 */
  /* 可选：子元素分布方式（两端对齐/均匀分布等） */
  /* justify-content: space-between; */
  /* 给个基础尺寸，可根据需求调整 */
  width: 96vw;
  height: 18%;
  /* 外填充（外边距）2vh */
  margin-top: 1vh;
  margin-left: 2vw;
  margin-right: 2vw;
  box-sizing: border-box;
  /*border: 10px;*/
}

.function-box2 {
  flex: 1;
  overflow: hidden;
  /* 隐藏滚动条 */
  /* 可选：优化滚动体验（iOS端） */
  -webkit-overflow-scrolling: touch;
  /* 核心：开启Flex布局，子元素自动横向排列 */
  display: flex;
  /* 可选：子元素之间的间距（按需调整） */
  gap: 10px;
  align-items: flex-start; /* 垂直顶部对齐 */
  justify-content: center; /* 水平居中对齐 */
  /* 可选：子元素分布方式（两端对齐/均匀分布等） */
  /* justify-content: space-between; */
  /* 给个基础尺寸，可根据需求调整 */
  width: 96vw;
  height: 18%;
  /* 外填充（外边距）2vh */
  margin-top: 1vh;
  margin-left: 2vw;
  margin-right: 2vw;
  box-sizing: border-box;
  /*border: 10px;*/
}

.child-box1 {
  /* 子元素基础样式（按需调整） */
  /* 开启Flex布局，子元素自动横向排列 */
  /*display: flex;*/
  /*flex: 1;*/ /* 两个子元素等分父容器宽度 */
  background-image: url('../resource/p2.jpg');
  background-size: 100% auto; /* 宽度100%占满，高度自动按比例适应 */
  background-position: center; /* 图片居中显示 */
  background-repeat: no-repeat; /* 防止图片重复 */
  border-radius: 5px;
  width: 94%;
  height: 100%;
}


.child-box4 {
  /* 子元素基础样式（按需调整） */
  /* 开启Flex布局，子元素自动横向排列 */
  /*display: flex;*/
  /*flex: 1;*/ /* 两个子元素等分父容器宽度 */
  background-image: url('../resource/p4.jpg');
  background-size: 100% auto; /* 宽度100%占满，高度自动按比例适应 */
  background-position: center; /* 图片居中显示 */
  background-repeat: no-repeat; /* 防止图片重复 */
  border-radius: 5px;
  width: 94%;
  height: 100%;
}

.font-bold-italic {
  color: #000; /* 字体加黑（黑色） */
  font-weight: bold; /* 加粗 */
  font-size: 28px;
  /*font-style: italic; *//* 斜体 */
}

.picture-italic {
  align-content: center;
  margin-top: 3%;
  width: 50%;
  height: 60%;
}

.text-order {
  padding: 2%;
}

.child-box2 {
  /* 子元素基础样式（按需调整） */
  /* 开启Flex布局，子元素自动横向排列 */
  /* display: flex;
   flex: 1; *//* 两个子元素等分父容器宽度 */
  background-image: url('../resource/p3.jpg');
  background-size: 100% auto; /* 宽度100%占满，高度自动按比例适应 */
  background-position: center; /* 图片居中显示 */
  background-repeat: no-repeat; /* 防止图片重复 */
  border-radius: 5px;
  width: 50%;
  height: 100%;
}

.child-box3 {
  /* 子元素基础样式（按需调整） */
  /* 开启Flex布局，子元素自动横向排列 */
  /* display: flex;*/
  flex: 1; /* 两个子元素等分父容器宽度 */
  background-image: url('../resource/p3.jpg');
  background-size: 100% auto; /* 宽度100%占满，高度自动按比例适应 */
  background-position: center; /* 图片居中显示 */
  background-repeat: no-repeat; /* 防止图片重复 */
  width: 94%;
  height: 100%;
  border-radius: 5px;
}

.child-box3-child1 {
  /* 子元素基础样式（按需调整） */
  /* 开启Flex布局，子元素自动横向排列 */
  display: flex;
  flex: 1; /* 两个子元素等分父容器宽度 */
  background-image: url('../resource/p3.jpg');
  background-size: 100% auto; /* 宽度100%占满，高度自动按比例适应 */
  background-position: center; /* 图片居中显示 */
  background-repeat: no-repeat; /* 防止图片重复 */
  margin-left: 2%;
  margin-top: 0.8vh;
  width: 94%;
  height: 45%;
  margin-bottom: 1%;
  border-radius: 5px;
}

.child-box3-child2 {
  /* 子元素基础样式（按需调整） */
  /* 开启Flex布局，子元素自动横向排列 */
  display: flex;
  flex: 1; /* 两个子元素等分父容器宽度 */
  background-image: url('../resource/p3.jpg');
  background-size: 100% auto; /* 宽度100%占满，高度自动按比例适应 */
  background-position: center; /* 图片居中显示 */
  background-repeat: no-repeat; /* 防止图片重复 */
  border-radius: 5px;
  margin-left: 2%;
  width: 94%;
  height: 45%;
  margin-top: 1%;
}

.dialog-class {
  margin-top: 1vh;
  margin-left: 2vw;
  margin-right: 2vw;
  /* 给个基础尺寸，可根据需求调整 */
  width: 80vw;
  height: 80vh;
}

/*图片弹框*/
.custom-vip {
  /* 圆角5px */
  border-radius: 5px;
  /* 外填充（外边距）2vh */
  /* 给个基础尺寸，可根据需求调整 */
  width: 100%;
  overflow: hidden;
  height: 100%;
}


/*人物DIV*/
.profile-div {
  display: flex;
  /* 圆角5px */
  border-radius: 5px;
  /* 背景图设置 */
  background-image: url('../resource/p1.png');
  /* 背景图自适应 */
  background-size: cover; /* 覆盖整个区域，可能裁剪 */
  /* 可选：保持背景图比例并完全显示 */
  /* background-size: contain; */
  /* 背景图位置居中 */
  background-position: center;
  /* 防止背景图重复 */
  background-repeat: no-repeat;
  /* 外填充（外边距）2vh */
  margin-top: 1vh;
  margin-left: 2vw;
  margin-right: 2vw;
  /* 给个基础尺寸，可根据需求调整 */
  width: 96vw;
  height: 25vh;
}

/*人物介绍*/
.text-profile {
  display: flex;
  font-size: 24px;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 25%;
  /* 文字渐变核心属性 */
  background: linear-gradient(to right, #e6f7ff, #1f9fff); /* 从浅蓝到深蓝，可修改颜色 */
  -webkit-background-clip: text; /* 裁剪背景到文字 */
  background-clip: text;
  color: transparent; /* 文字透明，显示背景渐变 */

}

/*人物图片*/
.profile-picture {
  display: flex;
  /* 给个基础尺寸，可根据需求调整 */
  width: 15%;
  height: 15%;
  /* 圆角5px */
  border-radius: 5px;
  /* 外填充（外边距）2vh */
  margin-top: 1vh;
  margin-left: 2vw;
  margin-right: 2vw;
}

/*走马灯开始*/
.el-carousel__item h3 {
  justify-content: center; /* 水平居中对齐 */
  display: flex;
  color: #475669;
  margin: 0;
}

.el-carousel__item:nth-child(2n) {
  background-color: #99a9bf;
}

.el-carousel__item:nth-child(2n + 1) {
  background-color: #d3dce6;
}


/*走马灯结束*/

/* 响应式设计 */
@media screen and (max-width: 768px) {
  .el-tabs__item {
    font-size: 12px;
    padding: 0 12px;
  }

  .el-menu-item, .el-submenu__title {
    height: 45px;
    line-height: 45px;
  }

  /* 移动端侧边栏激活时主内容区右移 */
  .mobile-main {
    transform: translateX(75%) translateX(-20px);
  }
}

/* 适配小屏幕 */
@media screen and (max-width: 480px) {
  .el-tabs__item {
    padding: 0 8px;
  }

  .mobile-aside {
    width: 80%;
  }

  .mobile-main {
    transform: translateX(80%) translateX(-20px);
  }
}
</style>